module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cz-con"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h2', [_vm._v("合伙人积分(配送)")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "alipayform",
    attrs: {
      "action": "api/user/transfer?tokenId=798cc3d3-56b0-44b2-848a-a3d6d306f253",
      "name": "transferForm",
      "method": "POST",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "element"
  }, [_c('div', {
    staticClass: "etitle"
  }, [_vm._v("支付密码:")]), _vm._v(" "), _c('div', {
    staticClass: "einput"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.consumeModel),
      expression: "consumeModel"
    }],
    attrs: {
      "type": "password",
      "id": "WIDtotal_fee",
      "name": "WIDtotal_fee",
      "value": "10"
    },
    domProps: {
      "value": (_vm.consumeModel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.consumeModel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "mark"
  }, [_vm._v("注意：请输入支付密码")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "element"
  }, [_c('input', {
    staticClass: "alisubmit",
    attrs: {
      "type": "button",
      "value": "确认查看"
    },
    on: {
      "click": _vm.confirm
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/account_logo.png"),
      "width": "200"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element",
    staticStyle: {
      "display": "none"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "id": "tokenId",
      "name": "tokenId",
      "value": "798cc3d3-56b0-44b2-848a-a3d6d306f253"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-caf6a7c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/account-center/showConsumeConfirm.vue
// module id = 1665
// module chunks = 1